import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/dist/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

class Hero {
    constructor(root) {
        this.root = root;
        
        this.init();
    }

    init() {
        this.anim = gsap.fromTo(this.root, {
            opacity: 0,
        }, {
            opacity: 1,
            duration: 0.3,
            ease: 'out',
            scrollTrigger: {
                trigger: this.root,
                start: 'top 90%',
                end: 'bottom 10%',
                invalidateOnRefresh: true,
                // markers: true,
            },
        });
    }

    destroy() {
        this.anim && this.anim.kill();
    }
}

export default {
    when() {
        return document.querySelectorAll('[data-hero]').length > 0
    },

    created() {
        this.instances = [];
        document.querySelectorAll('[data-hero]').forEach(root => {
            const instance = new Hero(root);
            this.instances.push(instance);
        });
    },

    destroyed() {
        this.instances.forEach(instance => {
            instance.destroy && instance.destroy();
        });
    }
}
